<template>
  <div
    class="d-flex flex-column w-100 h-100 routines-impact py-3 justify-space-between"
  >
    <div class="d-flex mb-3 align-start justify-start">
      <div class="me-1">
        <div class="routine-icon" />
      </div>
      <p class="ma-0 pa-0 routine-name-link" v-snip="2">
        {{ routine }}
      </p>
    </div>
    <div>
      <p class="ma-0 pa-0 h6 blue-grey--text text--darken-3">
        {{ metricText }}
      </p>
      <div v-if="!hidePercentageChange" class="cursor-pointer">
        <PercentageChangeChip
          :percentageChange="percentageChange"
          class="cursor-pointer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PercentageChangeChip from './PercentageChangeChip.vue'
import mixin from '../../../../mixins/mixin.vue'

export default {
  name: 'Impact',

  components: { PercentageChangeChip },

  mixins: [mixin],

  props: {
    routine: String,
    globalAverage: Number,
    percentageChange: Number,
    routineDefinitionId: String,
    metricText: String,
    hidePercentageChange: Boolean,
  },
}
</script>
<style lang="scss">
.routine-icon {
  border-radius: 2px 2px 2px 2px;
  background: #2f9aa9;
  width: 8px;
  height: 8px;
  margin-top: 1px;
}
.routine-name-link {
  color: $color-blue-grey-darken2 !important;
  text-decoration: none;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 11px;
  letter-spacing: -0.11px;
}
</style>
